// import React, { useState } from "react";
// import "./Navbar.css";
// import logo from "../Images/logo.webp"; // trust logo

// const Navbar = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <header className="navbar">
//       <div className="nav-container">
//         <a href="/" className="nav-logo">
//           <img src={logo} alt="SASCCT" />
//         </a>

//         <nav className={`nav-links ${open ? "active" : ""}`}>
//           <a href="/">Home</a>
//           <a href="#about-trust">About Trust</a>
//           <a href="/garuda-sena-details">Garuda Sena</a>
//           <a href="#gallery">Gallery</a>
//           <a href="#contact">Contact</a>
//           <a href="#join" className="join-btn">Join</a>
//         </nav>

//         <div className="nav-toggle" onClick={() => setOpen(!open)}>
//           <div className={`bar ${open ? "change" : ""}`}></div>
//           <div className={`bar ${open ? "change" : ""}`}></div>
//           <div className={`bar ${open ? "change" : ""}`}></div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;

import React, { useState } from "react";
import "./Navbar.css";
import logo1 from "../Images/GS2A.jpg";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  const handleMobileNavClick = () => {
    setOpen(!open);
    setAboutOpen(false);
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        <a href="/" className="nav-logo">
          <img src={logo1} alt="SASCCT" />
        </a>

        <nav className={`nav-links ${open ? "active" : ""}`}>
          <a href="/">Home</a>

          <div
            className={`dropdown ${aboutOpen ? "open" : ""}`}
            onClick={() => window.innerWidth <= 768 && setAboutOpen(!aboutOpen)}
          >
            <button className="dropbtn">
              About Trust 
            </button>
            <div className="dropdown-content">
              <a href="/about-us">About Us</a>
              <a href="/trustee-members">Trustee Members</a>
              <a href="/our-journey">Our Journey</a>
              <a href="/certification">Certification</a>
            </div>
          </div>
 <a href="/vip-members">VIP Members</a>
          <a href="/garuda-sena-details">Garuda Sena</a>
                       <a href="/volunteers">Volunteers</a>
          <a href="/gallery">Gallery</a>

          <a href="/contact">Contact</a>
          <a href="/enroll" className="join-btn" style={{width:"40px",backgroundColor:"#F2C94C", color: "#7B1E3A",
  padding: "8px 16px",
  borderRadius: "6px",
  fontWeight: "600",
  display: "inline-block",
  transition: "all 0.3s ease"}}>Join</a>
        </nav>

        <div className="nav-toggle" onClick={handleMobileNavClick}>
          <div className={`bar ${open ? "change" : ""}`}></div>
          <div className={`bar ${open ? "change" : ""}`}></div>
          <div className={`bar ${open ? "change" : ""}`}></div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
